import ProjectBrowseSidebarComponent from './project-browse-sidebar.component'

const ProjectBrowseSidebarModule = angular.module('cdbl.project-browse-sidebar', [

])
  .component('cdblProjectBrowseSidebar', ProjectBrowseSidebarComponent)
  .name

export default ProjectBrowseSidebarModule
